import { useNavigate } from "react-router";
import TableColumn from "./columns";
import FilterMenu from "./filter-menu";
import { useEffect, useState } from "react";
import API from "../../../services/api-request";
import { Card, Col, Flex, message, Row, Statistic, Table } from "antd";
import { useSearchParams } from "react-router-dom";
import "../../../assets/css/style-table.css";
import InvoicePrint from "../../../components/print/print_invoice";
import html2pdf from "html2pdf.js";

const Invoice = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sumPaid, setSumPaid] = useState(0);
  const [sumPending, setSumPending] = useState(0);

  const queryParams = Object.fromEntries([...searchParams]);
  const pagination = {
    current: parseInt(searchParams.get("page")) || 1,
    pageSize: parseInt(searchParams.get("limit")) || 10,
    total: totalData,
    onChange: (page, limit) => {
      pagination.current = page;
      pagination.pageSize = limit;
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("page", page);
      newSearchParams.set("limit", limit);
      setSearchParams(newSearchParams);
    },
  };

  const getInvoice = async (query) => {
    setData([]);
    const queryString = new URLSearchParams(query).toString();
    // Add default page and limit
    if (!searchParams.has("limit")) {
      searchParams.set("limit", 10);
    }
    if (!searchParams.has("page")) {
      searchParams.set("page", 1);
    }
    setSearchParams(searchParams);

    setLoading(true);
    API.Post(`invoice/list${query ? "?" + queryString : ""}`)
      .then((res) => {
        const page = query.page ? parseInt(query.page) - 1 : 0;
        const limit = query.limit ? parseInt(query.limit) : 10;

        setTotalData(res?.data?.data?.totalItems);
        setSumPaid(res?.data?.data?.sum_paid || 0);
        setSumPending(res?.data?.data?.sum_pending || 0);

        const formatSelect = res?.data?.data?.data?.map((item, index) => {
          return {
            ...item,
            no: page * limit + index + 1,
            verification_status:
              item?.payment_verification === "checked"
                ? "Pembayaran"
                : item?.nota_verification === "checked"
                  ? "Nota"
                  : "Pending",
          };
        });
        setData(formatSelect);
      })
      .catch((err) => {
        setData([]);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (queryParams) {
      getInvoice(queryParams);
    }
  }, [searchParams]);

  const handleNavigate = (data) => {
    navigate(`/transaction/detail/${data.id}`);
  };

  const handlePrint = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    printWindow.document.open();
    printWindow.document.write(InvoicePrint(data));
    setTimeout(function () {
      printWindow.document.close();
    }, 2000);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print({ showPrintDialog: true });

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  const handleDownload = (data) => {
    const watermarkStyle = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-image: url('/logo.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 30%;
    opacity: 0.08;
    z-index: 100;
    transform: rotate(-30deg);
    pointer-events: none;
  `;

    const invoiceHTML = InvoicePrint(data, watermarkStyle);

    const tempElement = document.createElement("div");
    tempElement.innerHTML = invoiceHTML;
    document.body.appendChild(tempElement);

    html2pdf()
      .set({
        margin: [10, 10, 0, 10],
        filename: `${data?.invoice_number || "unknown"}.pdf`,
        image: { type: "jpeg", quality: 1 },
        autoPaging: "text",
        html2canvas: {
          allowTaint: true,
          letterRendering: true,
          logging: false,
          scale: 3,
          height: 1000,
        },
        jsPDF: {
          unit: "mm",
          format: [241, 279], // 9.5 x 11 inch
          orientation: "portrait",
        },
      })
      .from(tempElement)
      .save()
      .then(() => {
        document.body.removeChild(tempElement);
      });
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <Row gutter={[8, 32]}>
        <Col span={24}>
          <Flex justify="flex-end" align="end" gap={16}>
            <Card variant="borderless" style={{ width: "15%" }}>
              <Statistic
                valueStyle={{
                  fontSize: "20px",
                }}
                title="Total Lunas"
                value={sumPaid?.toLocaleString("id-ID")}
                prefix="Rp"
              />
            </Card>

            <Card variant="borderless" style={{ width: "15%" }}>
              <Statistic
                valueStyle={{
                  fontSize: "20px",
                }}
                title="Total Belum Dibayar"
                value={sumPending?.toLocaleString("id-ID")}
                prefix={"Rp"}
              />
            </Card>
          </Flex>
        </Col>
      </Row>

      <FilterMenu />

      <Table
        style={{ maxWidth: "100%", overflow: "auto" }}
        rowClassName={rowClassName}
        columns={TableColumn(handleNavigate, handlePrint, handleDownload)}
        dataSource={data}
        rowKey={(dataSource) => dataSource.id}
        pagination={pagination}
        loading={loading}
        scroll={{ x: "max-content" }}
      />
    </>
  );
};

export default Invoice;
